import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FrozenPickAlertToast.css';

/**
 * Live-tab counterpart to the "frozen items to pick" OS push notification —
 * same shape as DeliveryAlertToast.js. Anchored top-LEFT (delivery's stack
 * owns top-right) so the two can never visually collide if both fire close
 * together.
 */
const FrozenPickAlertToast = ({ alerts, onDismiss }) => {
    const navigate = useNavigate();
    if (!alerts.length) return null;

    return (
        <div className="frozen-pick-alert-stack" role="region" aria-label="Frozen pick notifications">
            {alerts.map((alert) => (
                <div key={alert.id} className="frozen-pick-alert-toast" role="status">
                    <span className="frozen-pick-alert-toast__icon">🧊</span>
                    <div className="frozen-pick-alert-toast__body">
                        <div className="frozen-pick-alert-toast__title">{alert.title}</div>
                        <div className="frozen-pick-alert-toast__detail">{alert.detail}</div>
                    </div>
                    <button
                        type="button"
                        className="frozen-pick-alert-toast__open"
                        onClick={() => { navigate('/frozen-pick-portal'); onDismiss(alert.id); }}
                    >
                        Open
                    </button>
                    <button
                        type="button"
                        className="frozen-pick-alert-toast__close"
                        aria-label="Dismiss"
                        onClick={() => onDismiss(alert.id)}
                    >
                        &times;
                    </button>
                </div>
            ))}
        </div>
    );
};

export default FrozenPickAlertToast;
